{
  "general": {},
  "APP": {
    "APP-9F06": {
      "SRC": "APP",
      "Label": "EMV - AID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Authorisation Code": {
      "SRC": "APP",
      "Label": "Authorisation Code",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Authorised Amount": {
      "SRC": "APP",
      "Label": "Authorised Amount",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-BKM Result": {
      "SRC": "APP",
      "Label": "BKM Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Brand": {
      "SRC": "APP",
      "Label": "Brand",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Config Error": {
      "SRC": "APP",
      "Label": "Config Error",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Config File": {
      "SRC": "APP",
      "Label": "Config File",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Config Type": {
      "SRC": "APP",
      "Label": "Config Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Count": {
      "SRC": "APP",
      "Label": "Count",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-D1": {
      "SRC": "APP",
      "Label": "D1",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-D2": {
      "SRC": "APP",
      "Label": "D2",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-D3": {
      "SRC": "APP",
      "Label": "D3",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-DC": {
      "SRC": "APP",
      "Label": "DC",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-DD": {
      "SRC": "APP",
      "Label": "DD",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-DE": {
      "SRC": "APP",
      "Label": "DE",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Error": {
      "SRC": "APP",
      "Label": "Error",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-HID": {
      "SRC": "APP",
      "Label": "HID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Host Result": {
      "SRC": "APP",
      "Label": "Host Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-9F0D": {
      "SRC": "APP",
      "Label": "EMV - Issuer Action Code - Default",
      "Overview": 0,
      "Overview Label": 0,
      "Overview Detail": 1,
      "Overview Detail Label": 1,
      "Show missing": 1,
      "Primary": 0,
      "Hidden": 0
    },
    "APP-DFCA09": {
      "SRC": "APP",
      "Label": "Item ref",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-DFCA0E": {
      "SRC": "APP",
      "Label": "Transaction timestamp",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-DFCA5C": {
      "SRC": "APP",
      "Label": "Proprietary token",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Init Result": {
      "SRC": "APP",
      "Label": "Init Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Result": {
      "SRC": "APP",
      "Label": "Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-SAM App ID": {
      "SRC": "APP",
      "Label": "SAM App ID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "APP-Txn ID": {
      "SRC": "APP",
      "Label": "Txn ID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "AUTOSCAN": {
    "AUTOSCAN-Battery Level": {
      "SRC": "AUTOSCAN",
      "Label": "Battery Level",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "BOOT": {
    "BOOT-FW Name": {
      "SRC": "BOOT",
      "Label": "FW Name",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "BOOT-FW Version": {
      "SRC": "BOOT",
      "Label": "FW Version",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "BOOT-Status": {
      "SRC": "BOOT",
      "Label": "Status",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "Translate to hard/soft reboot"
    },
    "BOOT-Error": {
      "SRC": "BOOT",
      "Label": "Error",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "BOOT-Source": {
      "SRC": "BOOT",
      "Label": "Source",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "CARDEDGE": {
    "CARDEDGE-Total Memory": {
      "SRC": "CARDEDGE",
      "Label": "Total Memory",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "CARDEDGE-Free Memory": {
      "SRC": "CARDEDGE",
      "Label": "Free Memory",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "CCI": {
    "CCI-Type": {
      "SRC": "CCI",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "CCI-Amount": {
      "SRC": "CCI",
      "Label": "Amount",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "CCI-Item Nr": {
      "SRC": "CCI",
      "Label": "Item Nr",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "CCI-PTOS Result": {
      "SRC": "CCI",
      "Label": "PTOS Result",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "DEBUG": {
    "DEBUG-Log": {
      "SRC": "DEBUG",
      "Label": "Log",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "ETHERNET": {
    "ETHERNET-D2": {
      "SRC": "ETHERNET",
      "Label": "IP address",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "ETHERNET-D5": {
      "SRC": "ETHERNET",
      "Label": "DNS3",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "ETHERNET-State": {
      "SRC": "ETHERNET",
      "Label": "State",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "GPRS": {
    "GPRS-Operator": {
      "SRC": "GPRS",
      "Label": "Operator",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-CCID": {
      "SRC": "GPRS",
      "Label": "CCID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "In MyPayter there are know two tags: Sim and CCID"
    },
    "GPRS-Signal": {
      "SRC": "GPRS",
      "Label": "Signal",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-Signal History": {
      "SRC": "GPRS",
      "Label": "Signal strength history",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-GSN": {
      "SRC": "GPRS",
      "Label": "GSN",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-DD": {
      "SRC": "GPRS",
      "Label": "Signal strength history",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-DE": {
      "SRC": "GPRS",
      "Label": "IMEI",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-Error": {
      "SRC": "GPRS",
      "Label": "Error",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-F3": {
      "SRC": "GPRS",
      "Label": "Act code",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "***-Translate to UMT etc"
    },
    "GPRS-F7": {
      "SRC": "GPRS",
      "Label": "Baudrate",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-FA": {
      "SRC": "GPRS",
      "Label": "Error message",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-FB": {
      "SRC": "GPRS",
      "Label": "DNS1",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-FC": {
      "SRC": "GPRS",
      "Label": "DNS2",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "GPRS-State": {
      "SRC": "GPRS",
      "Label": "State",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "LOG": {
    "LOG-Type": {
      "SRC": "LOG",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "LOG-PTOS Result": {
      "SRC": "LOG",
      "Label": "PTOS Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "LOG-Flash Error": {
      "SRC": "LOG",
      "Label": "Flash Error",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "MDB": {
    "MDB-State": {
      "SRC": "MDB",
      "Label": "State",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "MDB-Type": {
      "SRC": "MDB",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "MDB-Master TX": {
      "SRC": "MDB",
      "Label": "Master TX",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "****-Translate to readable data in Elastic"
    },
    "MDB-Master RX": {
      "SRC": "MDB",
      "Label": "Master RX",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "****-Translate to readable data in Elastic"
    },
    "MDB-Reason": {
      "SRC": "MDB",
      "Label": "Reason",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 1,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "MDB_GAT": {},
  "PSP": {
    "PSP-State": {
      "SRC": "PSP",
      "Label": "State",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PSP-Type": {
      "SRC": "PSP",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PSP-Cmd": {
      "SRC": "PSP",
      "Label": "Cmd",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "PVP": {
    "PSP-Amount": {
      "SRC": "PVP",
      "Label": "Amount",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PVP-State": {
      "SRC": "PVP",
      "Label": "State",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 1,
      "Primary": 1,
      "Hidden": 0
    },
    "PVP-Type": {
      "SRC": "PVP",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PVP-Cmd": {
      "SRC": "PVP",
      "Label": "Cmd",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PVP-Reason": {
      "SRC": "PVP",
      "Label": "Reason",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "PVP-Amount": {
      "SRC": "PVP",
      "Label": "Amount",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "SAM": {
    "SAM-Serial": {
      "SRC": "SAM",
      "Label": "Serial",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "SAM-Applets": {
      "SRC": "SAM",
      "Label": "Applets",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "SAM-Card Id": {
      "SRC": "SAM",
      "Label": "Card Id",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "SAM-PTOS Result": {
      "SRC": "SAM",
      "Label": "PTOS Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "SPY": {
    "SPY-Reason": {
      "SRC": "SPY",
      "Label": "Reason",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "SPY-Error Cnt": {
      "SRC": "SPY",
      "Label": "Error Count",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "TCPIP": {
    "TCPIP-Error": {
      "SRC": "TCPIP",
      "Label": "Error",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TCPIP-DFCA01": {
      "SRC": "TCPIP",
      "Label": "Recover network reason",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TCPIP-Host": {
      "SRC": "TCPIP",
      "Label": "Host",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "TMS": {
    "TMS-Failed": {
      "SRC": "TMS",
      "Label": "Failed",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TMS-Attempts": {
      "SRC": "TMS",
      "Label": "Attempts",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  },
  "TXN": {
    "TXN-Txn ID": {
      "SRC": "TXN",
      "Label": "Txn ID",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-IFD Type": {
      "SRC": "TXN",
      "Label": "IFD Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Type": {
      "SRC": "TXN",
      "Label": "Type",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Authorised Amount": {
      "SRC": "TXN",
      "Label": "Authorised",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Capture Amount": {
      "SRC": "TXN",
      "Label": "Capture",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Brand": {
      "SRC": "TXN",
      "Label": "Brand",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-D9": {
      "SRC": "TXN",
      "Label": "Error text",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-5A": {
      "SRC": "TXN",
      "Label": "EMV - PAN",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0,
      "Notes": "*****-Only for proprietary, maybe only use other tag"
    },
    "TXN-5FE001": {
      "SRC": "TXN",
      "Label": "PP - Command result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-DFDA03": {
      "SRC": "TXN",
      "Label": "Vend amount",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Host Result": {
      "SRC": "TXN",
      "Label": "Host Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-PTOS Result": {
      "SRC": "TXN",
      "Label": "PTOS Result",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Status": {
      "SRC": "TXN",
      "Label": "Status",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Authorisation Code": {
      "SRC": "TXN",
      "Label": "Authorisation Code",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Authorisation Response Code": {
      "SRC": "TXN",
      "Label": "Authorisation Response Code",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-HID": {
      "SRC": "TXN",
      "Label": "HID",
      "Overview": 1,
      "Overview Label": 0,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    },
    "TXN-Online": {
      "SRC": "TXN",
      "Label": "Online",
      "Overview": 1,
      "Overview Label": 1,
      "Overview Detail": 0,
      "Overview Detail Label": 0,
      "Show missing": 0,
      "Primary": 1,
      "Hidden": 0
    }
  }
}
